module.exports = __webpack_public_path__ + "img/hav_logo.5a3a6bf5.svg";